import React from 'react';
import { Services } from './Store';

// @ts-expect-error keep this empty, it make no sense to fill in "defaults"
export const ServiceContext = React.createContext<Services>({});
